import InvoiceNumberSetUpForm from "components/utils/InvoiceNumberSetUpForm/InvoiceNumberSetUpForm";

function InvoiceNumberSetUpPage() {
  return <InvoiceNumberSetUpForm />;
}

export default InvoiceNumberSetUpPage;
